import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import s from './style/Layout.pcss';


class Header extends PureComponent {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  };

  render() {
    const [header, content] = this.props.children;
    return (
      <div className={s.container}>
        <div className={s.header}>{header}</div>
        <div className={s.content}>{content}</div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Root/Main/Layout.js